// Optional review fields must work with legacy APIs and preserve a real zero.
export function nullableMark(value) {
    if (value === null || value === undefined || typeof value === 'boolean' ||
        (typeof value !== 'number' && typeof value !== 'string') ||
        (typeof value === 'string' && value.trim() === '')) return null;
    const number = Number(value);
    return Number.isFinite(number) && number >= 0 ? number : null;
}

export function normalizeAttemptReview(attempt) {
    return {
        answer_attempt_id: attempt.id,
        correct: attempt.correct === true || attempt.correct === 1 ? true :
            (attempt.correct === false || attempt.correct === 0 ? false : null),
        question_mark: nullableMark(attempt.question_mark),
        correction_mark: nullableMark(attempt.correction_mark),
        // Reset rather than retain feedback from an earlier response/teacher grade.
        feedback: typeof attempt.feedback === 'string' ? attempt.feedback.trim() : null,
    };
}

export function answerReviewState(answer) {
    if (!answer) return 'unanswered';
    const mark = nullableMark(answer.correction_mark);
    const maximum = nullableMark(answer.question_mark);
    if (mark !== null && maximum !== null && maximum > 0) {
        if (mark === 0) return 'incorrect';
        return mark < maximum ? 'partial' : 'full';
    }
    if (answer.correct === true) return 'full';
    if (answer.correct === false) return 'incorrect';
    return answer.answer_attempt_id ? 'pending' : 'unanswered';
}

export function splitExamFeedback(value) {
    if (typeof value !== 'string') return {summary: '', steps: []};
    const summary = [], steps = [];
    value.split(/\r?\n/).forEach(line => {
        const bullet = line.trim().match(/^[•*-]\s+(.+)$/);
        if (bullet) steps.push(bullet[1]);
        else if (line.trim()) summary.push(line.trim());
    });
    return {summary: summary.join('\n'), steps};
}
